module.exports = __webpack_public_path__ + "img/1054_help_title_dd6ee1295.png";